module.exports = __webpack_public_path__ + "img/spotlight.a071077d.jpeg";